import { NextSeo } from 'next-seo'
import { PageType, useSEO } from '~/hooks/useSEO'
import CioBrowseResultPage from './CioBrowseResultPage'
import { VariationsStrategy } from './lib/constants'

type CioCmsPageProps = {
  slug: string
  filterName: string
  filterValue: string
  showVariationsStrategy?: VariationsStrategy
}

export const CioCmsPage = ({
  slug,
  filterName,
  filterValue,
  showVariationsStrategy,
}: CioCmsPageProps) => {
  const { canonical, languageAlternates } = useSEO({
    identifier: slug,
    type: PageType.CTF_CMS_PAGE,
  })

  return (
    <>
      {canonical && languageAlternates && (
        <NextSeo canonical={canonical} languageAlternates={languageAlternates} />
      )}
      <CioBrowseResultPage
        slug={slug}
        filterName={filterName}
        filterValue={filterValue}
        showVariationsStrategy={showVariationsStrategy}
      />
    </>
  )
}

export default CioCmsPage
